// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  IconUserCheck,
  IconBasket,
  IconMessages,
  IconLayoutKanban,
  IconMail,
  IconCalendar,
  IconNfc,
  IconUsers,
} from '@tabler/icons';

// constant
const icons = {
  IconUserCheck,
  IconBasket,
  IconMessages,
  IconLayoutKanban,
  IconMail,
  IconCalendar,
  IconNfc,
  IconUsers,
};

// ==============================|| APPLICATION MENU ITEMS ||============================== //

const application = {
  id: 'application',
  title: <FormattedMessage id='application' />,
  type: 'group',
  children: [
    // {
    //   id: 'users',
    //   title: <FormattedMessage id='users' />,
    //   type: 'collapse',
    //   icon: icons.IconUserCheck,
    //   children: [
    //     {
    //       id: 'posts',
    //       title: <FormattedMessage id='social-profile' />,
    //       type: 'item',
    //       url: '/user/social-profile/posts',
    //     },
    //     {
    //       id: 'account-profile',
    //       title: <FormattedMessage id='account-profile' />,
    //       type: 'collapse',
    //       children: [
    //         {
    //           id: 'profile1',
    //           title: (
    //             <>
    //               <FormattedMessage id='profile' /> 01
    //             </>
    //           ),
    //           type: 'item',
    //           url: '/user/account-profile/profile1',
    //         },
    //         {
    //           id: 'profile2',
    //           title: (
    //             <>
    //               <FormattedMessage id='profile' /> 02
    //             </>
    //           ),
    //           type: 'item',
    //           url: '/user/account-profile/profile2',
    //         },
    //         {
    //           id: 'profile3',
    //           title: (
    //             <>
    //               <FormattedMessage id='profile' /> 03
    //             </>
    //           ),
    //           type: 'item',
    //           url: '/user/account-profile/profile3',
    //         },
    //       ],
    //     },
    //     {
    //       id: 'user-card',
    //       title: <FormattedMessage id='cards' />,
    //       type: 'collapse',
    //       children: [
    //         {
    //           id: 'card1',
    //           title: (
    //             <>
    //               <FormattedMessage id='style' /> 01
    //             </>
    //           ),
    //           type: 'item',
    //           url: '/user/card/card1',
    //         },
    //         {
    //           id: 'card2',
    //           title: (
    //             <>
    //               <FormattedMessage id='style' /> 02
    //             </>
    //           ),
    //           type: 'item',
    //           url: '/user/card/card2',
    //         },
    //         {
    //           id: 'card3',
    //           title: (
    //             <>
    //               <FormattedMessage id='style' /> 03
    //             </>
    //           ),
    //           type: 'item',
    //           url: '/user/card/card3',
    //         },
    //       ],
    //     },
    //     {
    //       id: 'user-list',
    //       title: <FormattedMessage id='list' />,
    //       type: 'collapse',
    //       children: [
    //         {
    //           id: 'list1',
    //           title: (
    //             <>
    //               <FormattedMessage id='style' /> 01
    //             </>
    //           ),
    //           type: 'item',
    //           url: '/user/list/list1',
    //         },
    //         {
    //           id: 'list2',
    //           title: (
    //             <>
    //               <FormattedMessage id='style' /> 02
    //             </>
    //           ),
    //           type: 'item',
    //           url: '/user/list/list2',
    //         },
    //       ],
    //     },
    //   ],
    // },
    {
      id: 'inventory',
      title: <FormattedMessage id='inventory' />,
      type: 'collapse',
      icon: icons.IconBasket,
      children: [
        {
          id: 'product_Stock',
          title: <FormattedMessage id='product_Stock' />,
          type: 'item',
          url: '/app/products',
          breadcrumbs: true,
        },
        {
          id: 'material-stock',
          title: <FormattedMessage id='material-stock' />,
          type: 'item',
          url: '/app/material',
          breadcrumbs: true,
        },
      ],
    },
    {
      id: 'hrms',
      title: <FormattedMessage id='hrms' />,
      type: 'collapse',
      icon: icons.IconUsers,
      children: [
        {
          id: 'client',
          title: <FormattedMessage id='client' />,
          type: 'item',
          url: '/app/client-list',
          breadcrumbs: true,
        },
        {
          id: 'employee',
          title: <FormattedMessage id='employee' />,
          type: 'item',
          url: '/app/employee-list',
          breadcrumbs: true,
        },
        {
          id: 'vendor',
          title: <FormattedMessage id='vendor' />,
          type: 'item',
          url: '/app/vendor-list',
          breadcrumbs: true,
        },
        // {
        //   id: 'user',
        //   title: <FormattedMessage id='user' />,
        //   type: 'item',
        //   url: '/app/contact/c-list',
        //   breadcrumbs: true,
        // },
      ],
    },
    // {
    //   id: 'customer',
    //   title: <FormattedMessage id='customer' />,
    //   type: 'collapse',
    //   icon: icons.IconBasket,
    //   children: [
    //     {
    //       id: 'customer-list',
    //       title: <FormattedMessage id='customer-list' />,
    //       type: 'item',
    //       url: '/customer/customer-list',
    //       breadcrumbs: false,
    //     },
    //     {
    //       id: 'order-list',
    //       title: <FormattedMessage id='order-list' />,
    //       type: 'item',
    //       url: '/customer/order-list',
    //       breadcrumbs: false,
    //     },
    //     {
    //       id: 'order-details',
    //       title: <FormattedMessage id='order-details' />,
    //       type: 'item',
    //       url: '/customer/order-details',
    //     },
    //     {
    //       id: 'product',
    //       title: <FormattedMessage id='product' />,
    //       type: 'item',
    //       url: '/customer/product',
    //       breadcrumbs: false,
    //     },
    //     {
    //       id: 'product-review',
    //       title: <FormattedMessage id='product-review' />,
    //       type: 'item',
    //       url: '/customer/product-review',
    //       breadcrumbs: false,
    //     },
    //   ],
    // },
    // {
    //   id: 'chat',
    //   title: <FormattedMessage id='chat' />,
    //   type: 'item',
    //   icon: icons.IconMessages,
    //   url: '/app/chat',
    // },
    {
      id: 'production',
      title: 'Production',
      type: 'item',
      icon: icons.IconLayoutKanban,
      url: '/e-commerce/product-list',
      breadcrumbs: true,
    },
    {
      id: 'order',
      title: 'Order',
      type: 'item',
      icon: icons.IconBasket,
      url: '/app/order-list',
      breadcrumbs: true,
    },
    // {
    //   id: 'kanban',
    //   title: 'kanban',
    //   type: 'item',
    //   icon: icons.IconLayoutKanban,
    //   url: '/app/kanban',
    // },

    // {
    //   id: 'mail',
    //   title: <FormattedMessage id='mail' />,
    //   type: 'item',
    //   icon: icons.IconMail,
    //   url: '/app/mail',
    // },
    // {
    //   id: 'calendar',
    //   title: <FormattedMessage id='calendar' />,
    //   type: 'item',
    //   url: '/app/calendar',
    //   icon: icons.IconCalendar,
    //   breadcrumbs: false,
    // },
    // {
    //   id: 'contact',
    //   title: <FormattedMessage id='contact' />,
    //   type: 'collapse',
    //   icon: icons.IconNfc,
    //   children: [
    //     {
    //       id: 'c-card',
    //       title: <FormattedMessage id='cards' />,
    //       type: 'item',
    //       url: '/app/contact/c-card',
    //       breadcrumbs: false,
    //     },
    //     {
    //       id: 'c-list',
    //       title: <FormattedMessage id='list' />,
    //       type: 'item',
    //       url: '/app/contact/c-list',
    //       breadcrumbs: false,
    //     },
    //   ],
    // },
    // {
    //   id: 'e-commerce',
    //   title: <FormattedMessage id='e-commerce' />,
    //   type: 'collapse',
    //   icon: icons.IconBasket,
    //   children: [
    //     {
    //       id: 'products',
    //       title: <FormattedMessage id='products' />,
    //       type: 'item',
    //       url: '/e-commerce/products',
    //     },
    //     {
    //       id: 'product-details',
    //       title: <FormattedMessage id='product-details' />,
    //       type: 'item',
    //       url: '/e-commerce/product-details/default',
    //       breadcrumbs: false,
    //     },
    //     {
    //       id: 'product-list',
    //       title: <FormattedMessage id='product-list' />,
    //       type: 'item',
    //       url: '/e-commerce/product-list',
    //       breadcrumbs: false,
    //     },
    //     {
    //       id: 'checkout',
    //       title: <FormattedMessage id='checkout' />,
    //       type: 'item',
    //       url: '/e-commerce/checkout',
    //     },
    //   ],
    // },
  ],
};

export default application;
